<template>
  <div id="topic-filter">
    <!-- <b-input-group id="topic-searchbar">
      <b-form-input></b-form-input>
      <b-input-group-append>
        <b-button variant="info"><v-icon name="search"></v-icon></b-button>
      </b-input-group-append>
    </b-input-group> -->
    <sui-dropdown
      id="topic-searchbar"
      multiple
      fluid
      :options="topics"
      placeholder="Topics"
      search
      selection
      allow-additions
      v-model="chosenTopics"
    />
    <!-- <div id="topics"> 
      <b-button pill variant="info" class="px-2 py-0 topic">C++</b-button>
      <b-button pill variant="outline-info" class="px-2 py-0 topic">Javascript</b-button>
    </div> -->
    <div id="topics" class="hidden">
      <button
        class="ui button small topic"
        :class="{chosen: chosenTopics.includes(topic.value)}"
        v-for="topic in topics"
        :key="topic.key"
        @click="toggleTopic(topic)"
      >
        {{topic.text}}     
        <sui-label 
          :color="getColor(topic.num)"
          floating 
          size="mini"
          v-if="topic.num > 1"
        >
          {{topic.num}}
        </sui-label>
      </button>
    </div>
    <div id="dimmer" v-if="topicsHidden"></div>
    <div id="expand-btn" @click="expandTopics" v-if="topicsHidden">
      <v-icon name="angle-double-down" scale="1.5"></v-icon>
    </div>
    <div id="hide-btn" @click="hideTopics" v-else>
      <v-icon name="angle-double-up" scale="1.5"></v-icon>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      chosenTopicsProxy: [],
      topics: [],
      topicsHidden: true,
    }
  },
  computed: {
    chosenTopics: {
      get() {
        return this.$store.state.curTopics;
      },
      set(val) {
        this.chosenTopicsProxy = val;
        this.updateTopics(val);
      }
    }
  },
  created() {
    const topics = this.$store.state.topics;
    this.topics = Object.keys(topics).sort((a, b) => {
      return Object.keys(topics[b]).length - Object.keys(topics[a]).length;
    }).map((topic) => {
      return {
        key: topic,
        text: topic,
        value: topic,
        num: Object.keys(topics[topic]).length
      }
    });
  },
  methods: {
    ...mapActions([
      'updateTopics'
    ]),
    toggleTopic: function(topic) {
      const value = topic.value;
      if (!this.chosenTopics.includes(value)) {
        this.chosenTopics.push(value);
      } else {
        const idx = this.chosenTopics.indexOf(value);
        this.chosenTopics.splice(idx, 1);
      }
    },
    expandTopics() {
      delete document.querySelector('#topics').classList.remove('hidden');
      this.topicsHidden = false;
    },
    hideTopics() {
      delete document.querySelector('#topics').classList.add('hidden');
      this.topicsHidden = true;
    },
    getColor(num) {
      if (num > 15) {
        return 'red';
      } else if (num > 5) {
        return 'orange';
      } else {
        return 'yellow';
      }
    }
  },
  watch: {
    chosenTopics: function(newVal, oldVal) {
      this.chosenTopics = newVal;
    }
  }
}
</script>

<style>
#topic-filter {
  position: relative;
  width: 80%;
  margin: 24px auto 0;
  padding: 16px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}

div#topic-searchbar {
  background-color: rgba(0, 173, 181, 0.1);
}

#topic-searchbar input {
  color: #393E46;
}

#topic-searchbar .ui.label {
  color: #00ADB5;
  background-color: white;
  border: 1px solid #00ADB5;
  box-shadow: none;
  -webkit-box-shadow: none;
}

#topics {
  min-height: 24px;
  margin: 16px auto 0;
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

#topics.hidden {
  max-height: 124px;
  overflow: hidden;
}

#topics::after {
  content: "";
  flex: auto;
}

#topics .topic {
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 4px 8px;
  background-color: white;
  border: 1px solid #00ADB5;
  color: #00ADB5;
  position: relative;
}

#topics .topic .ui.label {
  font-size: 8px;
  min-width: 16px;
  padding: 2px;
  transform: translate(5px, 2px);
  z-index: 0;
}

#topics .topic.chosen {
  background-color: #00ADB5;
  border: 1px solid #00ADB5;
  color: white;
}

#expand-btn, #hide-btn {
  width: 32px;
  height: 32px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  right: 50%;
  color: #00ADB5;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

#expand-btn i, #hide-btn i {
  position: absolute;
  opacity: 0.5;
  top: 50%;
}

#dimmer {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 64px;
  background: linear-gradient(rgba(256, 256, 256, 0) 0, rgba(256, 256, 256) 100%);
}

@media screen and (max-width: 564px) {
  #topic-filter {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopicFilter.vue